import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

import ScrollArea from 'components/Shared/ScrollArea/Index'
import LoadingIndicator from 'components/Shared/LoadingIndicator/Index'
import Footer from 'components/App/Footer/Index'
import Notification from 'components/Shared/Notification/Index'

import { FOOTER_HEIGHT } from 'constants/constants'

const HORIZONTAL_PADDINGS = 32
const BOTTOM_PADDING = 32

const FixedHeaderWithScrolledArea = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  /* to set correct width of content when sidebar is visible */
  overflow-x: inherit;
`

const FixedHeader = styled.div`
  position: relative;
  z-index: 1;
`

const NotificationWrapper = styled.div`
  z-index: 1;
  position: relative;
  margin-top: 1px;
`

const StyledScrollArea = styled(ScrollArea)`
  transition: all 300ms;
  flex: 1;
  padding: ${props => props.noPadding ? '0' : `0 ${HORIZONTAL_PADDINGS}px 0 ${HORIZONTAL_PADDINGS}px;`};
  display: flex;
  flex-direction: column;
`

const ScrolledContentWrapper = styled.div`
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
`

const StyledFooter = styled(Footer)`
  ${props => props.parentHorizontalPadding && css`
    left: -${HORIZONTAL_PADDINGS}px;
    right: -${HORIZONTAL_PADDINGS}px;
    width: calc(100% + ${2 * HORIZONTAL_PADDINGS}px);
  `}
`

const StyledFooterWrapper = styled.div`
  height: ${FOOTER_HEIGHT}px;
`

const ContentFooter = ({ parentHorizontalPadding }) => {
  return (
    <StyledFooterWrapper>
      <StyledFooter parentHorizontalPadding={parentHorizontalPadding} />
    </StyledFooterWrapper>
  )
}

ContentFooter.propTypes = {
  parentHorizontalPadding: PropTypes.number,
}

const InnerContent = styled.div`
  flex: 1;
  padding-bottom: ${props => props.paddingBottom}px;
`

const Content = ({ children, className, loading, noPadding, fixedHeader }) => {
  return (
    <FixedHeaderWithScrolledArea>
      {fixedHeader && (
        <FixedHeader>{fixedHeader}</FixedHeader>
      )}

      <NotificationWrapper>
        <Notification />
      </NotificationWrapper>

      <StyledScrollArea className={className} noPadding={noPadding}>
        <ScrolledContentWrapper>
          <LoadingIndicator loading={!!loading} zIndex={10} />
          <InnerContent paddingBottom={noPadding ? 0 : BOTTOM_PADDING}>
            {children}
          </InnerContent>

          <ContentFooter parentHorizontalPadding={noPadding ? 0 : HORIZONTAL_PADDINGS} />
        </ScrolledContentWrapper>
      </StyledScrollArea>
    </FixedHeaderWithScrolledArea>
  )
}

Content.propTypes = {
  children: PropTypes.node,
  loading: PropTypes.bool,
  noPadding: PropTypes.bool,
  fixedHeader: PropTypes.node,
}

export default Content
